export class TrieNode<T> {
    children: { [key: string]: TrieNode<T> } = {};
    value: T | null = null;
}

export class Trie<T> {
    root = new TrieNode<T>();

    insert(guid: string, value: T): void {
        let node = this.root;
        for (let char of guid) {
            if (!node.children[char]) {
                node.children[char] = new TrieNode();
            }
            node = node.children[char];
        }
        node.value = value;
    }

    search(guid: string): T | null {
        let node = this.root;
        for (let char of guid) {
            if (!node.children[char]) {
                return null;
            }
            node = node.children[char];
        }
        return node.value;
    }
}